// extracted by mini-css-extract-plugin
export default {"page":"b91bcea6975a","action":"bfabf57c87ba"};